import { UserType } from "types/UsersTypes";
import "./user-status.scss";
import moment from "moment";

const UserStatus = ({ user }: { user: UserType }) => {
  const { status } = user;
  const now = moment();
  const isDeleted = user.deletedAt
    ? now.isAfter(moment(user.deletedAt))
    : false;

  return (
    <div className={`user-status`}>
      <span
        className={`user-status__label 
          ${status === "active" ? "user-status__label--active" : ""}
          ${status === "suspended" ? "user-status__label--blocked" : ""}
          ${status === "inactive" ? "user-status__label--inactive" : ""}
          ${isDeleted ? "user-status__label--deleted" : ""}`}
      >
        {isDeleted && "Usunięty"}
        {status === "active" && !isDeleted && "Aktywny"}
        {status === "suspended" && !isDeleted && "Zawieszony"}
        {status === "inactive" && !isDeleted && "Nieaktywny"}
      </span>
    </div>
  );
};

export default UserStatus;
